import { call, put, select, takeLatest } from 'redux-saga/effects'

import { AudienceInsightsSource } from '@enums'
import { IHateoasLink } from '@store'
import {
  AudienceInsightsActionTypes,
  fetchAudienceInsights,
  fetchAudienceInsightsError,
  fetchAudienceInsightsSuccess,
  fetchBrandConnectAudienceInsightsSuccess,
} from '@store/audienceInsights'
import { selectAuthToken } from '@store/auth'
import { selectIdentityAudienceInsightsLink } from '@store/brandFans'
import {
  selectAudienceInsightsLink,
  selectAudienceInsightsLinkByIdentityId,
  selectIsYouTubeBrandConnect,
} from '@store/submissions'
import { networkRequest } from '@utils'

export function* handleFetchAudienceInsights(action: ReturnType<typeof fetchAudienceInsights>) {
  try {
    const { identityId, source, submissionId } = action.payload
    const authToken: string = yield select(selectAuthToken)

    let audienceInsightsLink: IHateoasLink

    if (source === AudienceInsightsSource.Submission) {
      if (submissionId != null) {
        // Prefer link from the specific submission when provided
        audienceInsightsLink = yield select(selectAudienceInsightsLink, submissionId)
      } else {
        audienceInsightsLink = yield select(selectAudienceInsightsLinkByIdentityId, identityId)
      }
    } else {
      audienceInsightsLink = yield select(selectIdentityAudienceInsightsLink, identityId)
    }

    const audienceInsights = yield call(
      networkRequest,
      audienceInsightsLink.method,
      audienceInsightsLink.href,
      undefined,
      authToken,
    )

    // Check if this is a BrandConnect submission
    if (submissionId != null) {
      const isYouTubeBrandConnect: boolean = yield select(selectIsYouTubeBrandConnect, submissionId)
      if (isYouTubeBrandConnect) {
        // Dispatch BrandConnect-specific success action
        yield put(fetchBrandConnectAudienceInsightsSuccess(submissionId, audienceInsights))
        return
      }
    }

    // Standard audience insights success
    yield put(fetchAudienceInsightsSuccess(identityId, audienceInsights))
  } catch (error) {
    yield put(fetchAudienceInsightsError(error))
  }
}

function* watchFetchAudienceInsights() {
  yield takeLatest(AudienceInsightsActionTypes.FETCH_REQUEST, handleFetchAudienceInsights)
}

export const audienceInsightsSagas: ReadonlyArray<any> = [watchFetchAudienceInsights]
